export default () => import(/* webpackChunkName: 'coffee/activities/membership/home' */ './Home');
